import { Listeners, ReactiveState } from "./_helpers";
import { getElements, getElement } from "../utils/functional";

export default function init ({ el, context }) {

  let lastScrollPos = 0;
  let bodyElement = document.body;
  let transparentNav = bodyElement.classList.contains('index');
  const mainWrapper = document.getElementsByClassName('main')[0];
  const megaMenu = document.querySelector('.header__mega-menu');
  var initialHeaderHeight = headerElement.offsetHeight

  const pathNameArray = window.location.pathname.split("/");

  if (window.location.pathname === '/'){
    transparentNav = true;
  }

  pathNameArray.forEach( (pathName, index, array) => {
    if (pathName === 'collections' && array[3] !== 'products') { // Collection Page (and not product w/ collection in url)
      transparentNav = true;
    }
  })

  const processScroll = () => {
    var scrollY = window.scrollY || window.pageYOffset;
    var windowWidth = window.innerWidth;
    var translateY = 0;
    if(announcementElement){
      var announcementHeight = parseInt(announcementElement.offsetHeight + 1)
    } else {
      var announcementHeight = 1
    }

    var headerHeight = headerElement.offsetHeight - megaMenu.offsetHeight;

    if (scrollY < announcementHeight){

    } else if (scrollY >= announcementHeight){
      translateY = headerHeight
    }

    if(scrollY > lastScrollPos && scrollY >= announcementHeight){
      translateY = headerHeight + announcementHeight
    } else {
      translateY = 0;
      el.classList.add('nav-scrolling');
    }
    if(scrollY < announcementHeight){
      el.classList.remove('nav-scrolling')
    }
    

    
    el.style.transform = `translateY(-${translateY}px)`

    lastScrollPos = scrollY;

    setTimeout(function() {      
      if(!bodyElement.classList.contains('header-transparent') && windowWidth > 1024){
        mainWrapper.style.paddingTop = `${initialHeaderHeight}px`;
      } else {
        if(bodyElement.classList.contains('header-transparent')){

        } else {
          mainWrapper.style.paddingTop = `${initialHeaderHeight}px`;
        }
      }
    }, 200);
  }

  processScroll()
  
  window.addEventListener('resize', () => {
    processScroll()
  })
  window.addEventListener('scroll', () => {
    processScroll()
  })
}

const root = document.querySelector(":root"),
      headerElement = document.querySelector("#header"),
      announcementElement = document.querySelector('.announcement-bar')